import React, { FC, useId } from 'react';
import cls from './Select.module.scss';
import { Option, OptionValue } from './types';
import DropdownItemEntry from './DropdownItemEntry';
import CRMLoader from 'src/components/UI/Loaders/CRMLoader';
import InfiniteScroll from 'react-infinite-scroll-component';
interface DropdownProps {
  selectValue: (value: OptionValue, event?: React.MouseEvent) => void;
  options: Option[];
  width?: number;
  fetchNextPage?: () => void;
  hasMore: boolean;
  className?: string;
  hoveredElementKey: string | number | null | undefined;
  setHoveredElementKey: (value: string | number | null | undefined) => void;
}
const Dropdown: FC<DropdownProps> = ({
  selectValue,
  options,
  width,
  fetchNextPage,
  hasMore,
  className,
  hoveredElementKey,
  setHoveredElementKey,
}) => {
  const id = useId();

  return (
    <div style={{ borderRadius: '15px', overflow: 'hidden', width }}>
      <div
        id={id}
        className={`${cls.dropdown} ${className}`}
        style={{
          width: width,
        }}
      >
        <InfiniteScroll
          onScroll={() => setHoveredElementKey(null)}
          dataLength={options.length}
          next={
            fetchNextPage
              ? fetchNextPage
              : () => {
                  null;
                }
          }
          //for test loader design
          // next={() => {null}}
          hasMore={hasMore}
          loader={
            <div className={`${cls['option']} flex-block-center`}>
              <CRMLoader size={20} />
            </div>
          }
          scrollableTarget={id}
        >
          {options.map((option) => (
            <DropdownItemEntry
              hoveredElementKey={hoveredElementKey}
              setHoveredElementKey={setHoveredElementKey}
              key={option.key || option.value}
              option={option}
              selectValue={selectValue}
            />
          ))}
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default Dropdown;
